var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.label("title"),
        visible: _vm.visible,
        width: "90%",
        top: "5vh",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.invalidate,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "postage-review",
          attrs: { "aria-busy": _vm.loading },
        },
        [
          _c("div", { staticClass: "postage-review__context" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.label("invoice")) + ": "),
              _c("strong", [_vm._v(_vm._s(_vm.context.invoiceNumber))]),
            ]),
            _c("span", [
              _vm._v(_vm._s(_vm.label("carrier")) + ": "),
              _c("strong", [_vm._v(_vm._s(_vm.context.logisticsCompany))]),
            ]),
            _c("div", { staticClass: "postage-review__file" }, [
              _vm._v(
                _vm._s(_vm.label("file")) + ": " + _vm._s(_vm.context.fileName)
              ),
            ]),
          ]),
          _vm.error
            ? _c("el-alert", {
                attrs: {
                  title: _vm.label("error"),
                  type: "error",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm.result
            ? [
                _c("div", { staticClass: "postage-review__totals" }, [
                  _c("div", { staticClass: "postage-review__card" }, [
                    _c("span", [_vm._v(_vm._s(_vm.label("current")))]),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.money(_vm.result.currentChargeAmount))),
                    ]),
                  ]),
                  _c("div", { staticClass: "postage-review__card" }, [
                    _c("span", [_vm._v(_vm._s(_vm.label("total")))]),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.money(_vm.result.customerChargeTotal))),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.result.rows,
                      border: "",
                      stripe: "",
                      "max-height": "460",
                      "show-summary": "",
                      "summary-method": _vm.summary,
                      "empty-text": _vm.label("empty"),
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.label("no"),
                        width: "65",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "customerInvoiceId",
                        label: _vm.label("customerInvoice"),
                        "min-width": "190",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.customerInvoiceId ||
                                      _vm.label("notInvoiced")
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1157352642
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "clientCode",
                        label: _vm.label("client"),
                        "min-width": "130",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "chargedPrice",
                        label: _vm.label("charged"),
                        "min-width": "160",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.money(scope.row.chargedPrice))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1952678303
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.loading, icon: "el-icon-refresh" },
              on: { click: _vm.load },
            },
            [_vm._v(_vm._s(_vm.label(_vm.error ? "retry" : "refresh")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.loading || !_vm.result || _vm.error,
                icon: "el-icon-download",
              },
              on: { click: _vm.exportCsv },
            },
            [_vm._v(_vm._s(_vm.label("export")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.label("close")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }